import moment from "moment";
import SelectModelSearchInputComponent from "../../../../components/model/select-model-search-input.component";
import paginationComponent from "../../../../components/pagination/pagination.component";
import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import SelectSiteGroupComponent from "../../../../components/site/select-site-group.component";
import SelectSiteSearchInputComponent from "../../../../components/site/select-site-search-input.component";
import { formats } from "../../../../config/constants";
import StoreStockoutWithEulaModel from "../../../../models/reports/psi/store-stockout-with-eula.model";
import ViewBase from "../../../view-base.view";

export default function StoreStockoutWithEulaView() {
  ViewBase.call(this);

  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';

  let weekRangeFrom = moment().format(formats.WEEK_FORMAT);
  let weekRangeTo = moment().format(formats.WEEK_FORMAT);

  let selectedSiteGroups = [];

  let selectedSites = [];

  let isShowAssumedSellout = false;

  let options = [];
  let selectedOption;

  let selectedModels = [];

  let layoutColumns = [];
  let selectedLayoutColumn;

  let isDownloadingExcel = false;
  let isDownloadingRawData = false;
  let isDownloadingSellInDetails = false;

  let selectedSortBy = "";
  let selectedOrderBy = "";

  const pagination = {
    pageIndex: 1,
    pageSize: 10,
    totalItems: 0,
  };

  let searchResult;

  let prevSearchCache = {
    weekRangeFrom,
    weekRangeTo,
    selectedSiteGroups,
    selectedSites,
    isShowAssumedSellout,
    selectedOption,
    selectedModels,
    selectedLayoutColumn,

    updateCache() {
      this.weekRangeFrom = weekRangeFrom;
      this.weekRangeTo = weekRangeTo;
      this.selectedSiteGroups = selectedSiteGroups;
      this.selectedSites = selectedSites;
      this.isShowAssumedSellout = isShowAssumedSellout;
      this.selectedOption = selectedOption;
      this.selectedModels = selectedModels;
      this.selectedLayoutColumn = selectedLayoutColumn;
    }
  }

  const handleChangeWeekRangeFrom = (e) => {
    weekRangeFrom = moment(e.target.value).format(formats.WEEK_FORMAT)
  }
  const handleChangeWeekRangeTo = (e) => {
    weekRangeTo = moment(e.target.value).format(formats.WEEK_FORMAT)
  }

  const handleSelectSiteGroups = (siteGroups) => {
    selectedSiteGroups = siteGroups;
  }

  const handleSelectSites = (sites) => {
    selectedSites = sites;
  };

  const handleChangeShowAssumedSellout = (e) => {
    isShowAssumedSellout = e.target.checked;
  }

  const handleSelectOption = (option) => {
    selectedOption = option;
  }

  const handleSelectModels = (models) => {
    selectedModels = models;
  }

  const createTableActionConfig = () => {
    return {
      sortBy: selectedSortBy,
      orderBy: selectedOrderBy,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      dateFrom: moment(prevSearchCache.weekRangeFrom).format(formats.API_WEEK_FORMAT),
      dateTo: moment(prevSearchCache.weekRangeTo).format(formats.API_WEEK_FORMAT),
      siteGroup: prevSearchCache.selectedSiteGroups.map(siteGroup => `${siteGroup.code}^${siteGroup.name}`).join("|"),
      siteCode: prevSearchCache.selectedSites.map(site => `${site.siteId}^${site.siteName}`).join("|"),
      assumedSellout: prevSearchCache.isShowAssumedSellout,
      reportOption: prevSearchCache.selectedOption?.code,
      modelCode: prevSearchCache.selectedModels.filter(model => model.modelCode).map(model => `${model.modelCode}^${model.modelDesc}`).join("|"),
      modelAB: prevSearchCache.selectedModels.filter(model => model.modelAlias).map(model => `${model.modelAlias}^${model.modelDesc}`).join("|"),
      reportType: prevSearchCache.selectedLayoutColumn?.code,
    }
  }

  const handleClickDownloadExcel = (e) => {
    e.preventDefault();
    isDownloadingExcel = true;

    StoreStockoutWithEulaModel.downloadExcel(createTableActionConfig())
      .catch((err) => {
        this.handleError(err)
      })
      .finally(() => {
        isDownloadingExcel = false;
      })
  }

  const handleClickDownloadRawData = (e) => {
    e.preventDefault();
    isDownloadingRawData = true;

    StoreStockoutWithEulaModel.downloadRawData(createTableActionConfig())
      .catch((err) => {
        this.handleError(err)
      })
      .finally(() => {
        isDownloadingRawData = false;
      })
  }

  const handleClickDownloadSellInDetails = (e) => {
    e.preventDefault();
    isDownloadingSellInDetails = true;

    StoreStockoutWithEulaModel.downloadSellInDetails(createTableActionConfig())
      .catch((err) => {
        this.handleError(err)
      })
      .finally(() => {
        isDownloadingSellInDetails = false;
      })
  }

  const handleSelectLayoutColumn = (layoutColumn) => {
    selectedLayoutColumn = layoutColumn;
  }

  const search = () => {

    this.showLoading();

    const config = {
      sortBy: "", // use default value because of columns are dynamic
      orderBy: "", // use default value because of columns are dynamic
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      dateFrom: moment(weekRangeFrom).format(formats.API_WEEK_FORMAT),
      dateTo: moment(weekRangeTo).format(formats.API_WEEK_FORMAT),
      siteGroup: selectedSiteGroups.map(siteGroup => `${siteGroup.code}^${siteGroup.name}`).join("|"),
      siteCode: selectedSites.map(site => `${site.siteId}^${site.siteName}`).join("|"),
      assumedSellout: isShowAssumedSellout,
      reportOption: selectedOption?.code,
      modelCode: selectedModels.filter(model => model.modelCode).map(model => `${model.modelCode}^${model.modelDesc}`).join("|"),
      modelAB: selectedModels.filter(model => model.modelAlias).map(model => `${model.modelAlias}^${model.modelDesc}`).join("|"),
      reportType: selectedLayoutColumn?.code,
    }

    StoreStockoutWithEulaModel.search(config)
      .then((res) => {
        searchResult = res?.data || [];

        pagination.totalItems = res?.total || 0;
        pagination.pageIndex = res?.pageIndex || 1;
        pagination.pageSize = res?.pageSize || 10;

        selectedSortBy = "";
        selectedOrderBy = "";

        prevSearchCache.updateCache();
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const searchWithCache = () => {

    this.showLoading();

    const config = createTableActionConfig();

    StoreStockoutWithEulaModel.search(config)
      .then((res) => {
        searchResult = res?.data || [];

        pagination.totalItems = res?.total || 0;
        pagination.pageIndex = res?.pageIndex || 1;
        pagination.pageSize = res?.pageSize || 10;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    e.target.classList.add("was-validated");

    if (!e.target.checkValidity()) {
      e.stopPropagation();
      return;
    }

    pagination.pageIndex = 1;
    search();
  };

  const handleClickClear = () => {
    weekRangeFrom = moment().format(formats.WEEK_FORMAT);
    weekRangeTo = moment().format(formats.WEEK_FORMAT);
    selectedSiteGroups = [];
    selectedSites = [];
    isShowAssumedSellout = false;
    selectedOption = undefined;
    selectedModels = [];
    selectedLayoutColumn = undefined;
  }

  const handlePageChanged = (page) => {
    pagination.pageIndex = page;
    searchWithCache();
  };

  const handlePageSizeChanged = (page, size) => {
    pagination.pageIndex = page;
    pagination.pageSize = size;
    searchWithCache();
  };

  const fetchInitData = () => {
    this.showLoading();

    Promise.all([
      StoreStockoutWithEulaModel.getOptions(),
      StoreStockoutWithEulaModel.getLayoutColumns(),
    ])
      .then(([optionsRes, layoutColumnsRes]) => {
        options = optionsRes;
        layoutColumns = layoutColumnsRes;
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  };

  const flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT;
  }

  const getSortIcon = (orderBy) => {
    if (selectedOrderBy !== orderBy) {
      return null;
    }

    return selectedSortBy === DESCENDING_TEXT
      ? m('i.bi.bi-sort-down')
      : m('i.bi.bi-sort-up');
  };

  const onSortClick = (orderBy) => {
    if (selectedOrderBy === orderBy) {
      selectedSortBy = flipOrderText(selectedSortBy);
    } else {
      selectedOrderBy = orderBy;
      selectedSortBy = DESCENDING_TEXT;
    }
    searchWithCache();
  };

  // get all title.code except values of "Category (Option)" and a sequence of digits (stands for Weeks)
  const getTitleGroups = (titles) => {
    return titles.filter(title => !/\d+/.test(title.code) && title.code !== "Category (Option)");
  }

  const sortTitles = (titles = []) => {
    titles = [...titles];
    titles.sort((a, b) => a.rowId - b.rowId);

    return titles;
  }

  // data from BE:
  // titles: map to table columns
  // data rows: map to table rows - the order is incorrect in comparison with table columns 
  const convertRowData = (titles = [], rows = []) => {
    let newOrderedRows = [];
    let newOrderedTitles = sortTitles(titles);

    // make sure order of table row data (td) is aligned with table header (th)
    rows.forEach((rowObj) => {
      let newRow = [];
      newOrderedTitles.forEach((title) => {
        if (title.code in rowObj) {
          newRow.push(rowObj[title.code]);
        } else {
          newRow.push(null);
        }
      });

      newOrderedRows.push(newRow);
    });

    let titlesToGroup = getTitleGroups(newOrderedTitles);

    // group data by composing keys: compose all keys (of titles) except "Categories (Options)" and Weeks (contains only digits)
    let group = new Map();

    for (let row of newOrderedRows) {
      const key = row.slice(0, titlesToGroup.length).toString();

      if (!group.has(key)) {
        group.set(key, [row])
      } else {
        group.get(key).push(row)
      }

    }

    return { group, titlesToGroup };
  };

  const createDynamicTableRows = ({ group, titlesToGroup }) => {
    let rowsEle = [];

    for (let rowsGroupData of group.values()) {

      rowsGroupData.forEach((rowData, rowIdx) => {
        let rowEle = [];

        const containsAssumedSellout = rowData.find((cell) => typeof cell === "string" && cell.includes("ASSUMED SELL-OUT"));

        rowData.forEach((cell, cellIdx) => {

          let showCellData = !(rowIdx > 0 && cellIdx < titlesToGroup.length);

          // mark assumed sellout value as red when value is 0
          const markTextAsRed = isShowAssumedSellout && containsAssumedSellout && cell === 0;

          rowEle.push(m("td", { class: markTextAsRed && "text-danger" }, showCellData ? cell : null));
        });

        rowsEle.push(m("tr", { style: rowIdx === 0 && "background-color:rgb(173,216,230);" }, rowEle));
      });
    }

    return rowsEle;
  };

  return {
    oninit: () => {
      fetchInitData();
    },

    view: () => {
      return [
        m('.d-flex.justify-content-end.mb-2',
          m('a.btn.btn-primary[data-bs-toggle="collapse"][href="#search-section"][aria-controls="search-section"][aria-expanded="true"]',
            m('i.bi.bi-filter'),
            this.getText("LT00000232", "Filter"),
          ),
        ),

        m('#search-section.collapse.show',
          m(".card",
            m(".card-body",
              m("form.row.g-2.needs-validation[novalidate]", {
                onsubmit: handleSubmitSearch
              },

                m(".col-md-6.col-xl-3.position-relative",
                  m("label.form-label.mandatory[for='week-range-from']", this.getText("LT00001160", "Week Range")),
                  m('.d-flex.flex-wrap.flex-md-nowrap.gap-1.align-items-center',
                    m('input#week-range-from.form-control[name="week-range-from"][type="week"][required]', {
                      style: "min-width:0px;",
                      value: weekRangeFrom,
                      max: weekRangeTo,
                      onchange: handleChangeWeekRangeFrom,
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                    m('span', '~'),
                    m('input#week-range-to.form-control[name="week-range-to"][type="week"][required]', {
                      style: "min-width:0px;",
                      value: weekRangeTo,
                      min: weekRangeFrom,
                      onchange: handleChangeWeekRangeTo
                    }),
                    m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                  )
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for=site-group']", this.getText("LT00000072", "Site Group")),
                  m(SelectSiteGroupComponent, {
                    id: "site-group",
                    selectedItems: selectedSiteGroups,
                    onChange: handleSelectSiteGroups
                  }),
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m("label.form-label[for='site']", this.getText("LT00000071", "Site")),
                  m(SelectSiteSearchInputComponent, {
                    id: "site",
                    multiple: true,
                    selectedItems: selectedSites,
                    onSelect: handleSelectSites,
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m(".d-flex.align-items-center.h-100",
                    m("input#show-assumed-sellout.me-1[type='checkbox']", {
                      checked: isShowAssumedSellout,
                      onchange: handleChangeShowAssumedSellout
                    }),
                    m("label[for='show-assumed-sellout']", this.getText("LT00001161", "Show Assumed Sellout")),
                  ),
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m('label.form-label.mandatory[for="option"]', this.getText("LT00001162", "Options")),
                  m(SingleSelectComponent, {
                    id: "option",
                    items: options,
                    selectedItem: selectedOption,
                    itemKey: "code",
                    itemValue: "name",
                    filterable: true,
                    required: true,
                    onSelect: handleSelectOption,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m('label.form-label[for="model-search"]', this.getText("LT00001163", "Model Search")),
                  m(SelectModelSearchInputComponent, {
                    id: "model-search",
                    selectedItems: selectedModels,
                    multiple: true,
                    EULA: true,
                    onSelect: handleSelectModels,
                  })
                ),

                m(".col-md-6.col-lg-3.position-relative",
                  m('label.form-label.mandatory[for="layout-columns"]', this.getText("LT00001164", "Layout Columns")),
                  m(SingleSelectComponent, {
                    id: "layout-columns",
                    items: layoutColumns,
                    selectedItem: selectedLayoutColumn,
                    itemKey: "code",
                    itemValue: "name",
                    filterable: true,
                    required: true,
                    onSelect: handleSelectLayoutColumn,
                  }),
                  m('.invalid-tooltip', this.getText("LT00000729", "This field is required")),
                ),

                m(".row.g-2.justify-content-end.mt-2.mt-md-3",
                  m(".col-12.gap-2.d-flex.justify-content-end.flex-wrap",
                    m("button.btn.btn-primary",
                      this.getText("LT00000001", "Search")
                    ),

                    m("button.btn.btn-white[type=button]",
                      { onclick: handleClickClear },
                      this.getText("LT00000031", "Clear")
                    )
                  )
                )
              ),
            ),
          ),
        ),

        searchResult &&
        m(".mt-2.card",
          m(".card-body",

            searchResult?.[0]?.data?.length > 0 &&
            m("div",

              m('.d-flex.justify-content-end.mb-2',
                m('.input-group.w-auto',
                  m('button.btn.btn-primary.dropdown-toggle.dropdown-toggle-split[type=button][data-bs-toggle=dropdown][arie-expanded=false]',
                    {
                      disabled: !searchResult,
                    },
                    isDownloadingExcel || isDownloadingRawData || isDownloadingSellInDetails
                      ? m('span.spinner-border.spinner-border-sm.me-2[role=status][aria-hidden=true]')
                      : m('i.bi.bi-file-earmark-arrow-down-fill'),
                    this.getText("LT00000492", "Download")
                  ),
                  m('ul.dropdown-menu',
                    m('li',
                      m('a.dropdown-item[href="javascript:void(0);"]', {
                        class: isDownloadingExcel ? 'disabled' : '',
                        onclick: handleClickDownloadExcel
                      },
                        isDownloadingExcel && m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                        this.getText("LT00001165", "Download Excel")
                      )
                    ),
                    m('li',
                      m('a.dropdown-item[href="javascript:void(0);"]', {
                        class: isDownloadingRawData ? 'disabled' : '',
                        onclick: handleClickDownloadRawData
                      },
                        isDownloadingRawData && m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                        this.getText("LT00001166", "Download Raw Data")
                      )
                    ),
                    m('li',
                      m('a.dropdown-item[href="javascript:void(0);"]', {
                        class: isDownloadingSellInDetails ? 'disabled' : '',
                        onclick: handleClickDownloadSellInDetails
                      },
                        isDownloadingSellInDetails &&
                        m('span.spinner-border.spinner-border-sm.text-secondary.me-2[role=status]'),
                        this.getText("LT00001167", "Download Sell-in Details")
                      )
                    ),
                  ),
                ),
              ),

              m(".table-responsive.mt-2",
                m("table.table.align-middle", [
                  m("thead",
                    m("tr", sortTitles(searchResult?.[0]?.titles).map(title => {

                      const isWeekColumn = /\d+/.test(title.code);

                      return m("th[scope=col]", {
                        onclick: !isWeekColumn && (() => { onSortClick(title.code) }),
                        class: !isWeekColumn ? "cursor-pointer" : ""
                      }, getSortIcon(title.code), title.name)
                    }),
                    )
                  ),

                  m("tbody",
                    createDynamicTableRows(convertRowData(searchResult?.[0]?.titles, searchResult?.[0]?.data)),
                  ),
                ])
              ),

              m(".px-3",
                m(paginationComponent, {
                  currentPage: pagination.pageIndex,
                  pageSize: pagination.pageSize,
                  totalItems: pagination.totalItems,
                  data: searchResult,
                  onPageChanged: handlePageChanged,
                  onPageSizeChanged: handlePageSizeChanged,
                })
              )
            ),

            searchResult?.[0]?.data?.length === 0 && this.getText("EM00000141", "No records found.")

          )
        ),

        this.getBaseViews()
      ]
    }
  }
}